import request from 'services/axios';

export const chooseWinner = async (
  payload: IChooseWinner,
  cardType: 'auction' | 'prepayment',
) => {
  const response = await request.patch(
    `/api/v2/market/${
      cardType === 'auction' ? 'price-suggestion' : 'prepayment-suggestion'
    }`,
    {
      guid: payload.guid,
      delete: `${payload.delete}`,
    },
  );
  return response;
};
